import { render, staticRenderFns } from "./journal-list.vue?vue&type=template&id=0704c0d8"
import script from "./journal-list.vue?vue&type=script&lang=js"
export * from "./journal-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports